// import hasSampledVariantSelector from 'modules/variant/redux/selectors/has-sampled'

import logUtil from 'utils/log'
import getFreeBonusDeluxeSamplesCountCartSelect from 'modules/cart/redux/selectors/get-free-bonus-deluxe-samples-count'
import isSelectFreeBonusDeluxeSamplesStepGiftSelect from 'modules/gift/redux/selectors/is-select-bonus-deluxe-samples-step'
import { MAX_DELUXE_SAMPLES_COUNT_ON_FIRST_ORDER } from 'modules/cart/constants'
import updateCurrentToastAction from 'modules/toast/redux/actions/update-current'
import updateIsFreeBonusDeluxeSampleCartUtil from 'modules/cart/utils/update-is-free-bonus-deluxe-sample'

const YOU_CANT_ADD_MORE = `You can’t add more than ${MAX_DELUXE_SAMPLES_COUNT_ON_FIRST_ORDER} free deluxe samples`

/**
 * @param {handleAddCartActionProps} props
 * @returns {(function(*, *): Promise<undefined|{wasRemoved: *, wasAdded}>)|*}
 */
export default function beforeAddCartAction (props) {
  return (dispatch, getState) => {
    const { variantId } = props
    const isSelectFreeBonusDeluxeSamplesStep = isSelectFreeBonusDeluxeSamplesStepGiftSelect(getState())
    const logPrefix = `variantId=${variantId}`
    if (!isSelectFreeBonusDeluxeSamplesStep) {
      logUtil('beforeAddCartAction').debug(`${logPrefix} [noop] not free bonus deluxe sample step`)
      return true
    }

    const freeBonusDeluxeSamplesCount = getFreeBonusDeluxeSamplesCountCartSelect(getState())
    if (freeBonusDeluxeSamplesCount >= MAX_DELUXE_SAMPLES_COUNT_ON_FIRST_ORDER) {
      logUtil('beforeAddCartAction').debug(`${logPrefix} [noop] reached max`)
      dispatch(updateCurrentToastAction(YOU_CANT_ADD_MORE))
      return
    }

    logUtil('beforeAddCartAction').debug(`${logPrefix} [done]`)
    updateIsFreeBonusDeluxeSampleCartUtil(variantId)
    return true
  }
}
